export default "__VITE_ASSET__BkZuOCsS__"